import React, { createContext, useContext, useState, useMemo, useCallback } from 'react'

const APP_USER_CONFIRMED_STORAGE_KEY = 'trafficFineConfirmedUserData'

const createEmptyUserData = () => ({
  phoneNumberFromSdk: '',
  phoneNumberWithUsernamePrefix: '',
  sdkToken: null
})

export const cleanPhoneNumber = (phoneNumber) => String(phoneNumber || '').replace(/\D/g, '')

export const buildPhoneNumberWithUsernamePrefix = (phoneNumberFromSdk, usernamePrefix) => {
  if (!phoneNumberFromSdk) {
    return ''
  }
  return `${usernamePrefix || ''}${phoneNumberFromSdk}`
}

const saveConfirmedUserData = (userData) => {
  try {
    localStorage.setItem(APP_USER_CONFIRMED_STORAGE_KEY, JSON.stringify({
      phoneNumberFromSdk: userData?.phoneNumberFromSdk || '',
      phoneNumberWithUsernamePrefix: userData?.phoneNumberWithUsernamePrefix || '',
      sdkToken: userData?.sdkToken || null
    }))
  } catch (error) {
    console.error('Failed to save user data to localStorage', error)
  }
}

const getStoredConfirmedUserData = () => {
  try {
    const data = localStorage.getItem(APP_USER_CONFIRMED_STORAGE_KEY)
    return data ? JSON.parse(data) : createEmptyUserData()
  } catch (error) {
    return createEmptyUserData()
  }
}

export const AppUserContext = createContext(null)

export const AppUserContextProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => getStoredConfirmedUserData())

  const confirmSdkTokenData = useCallback(
    (sdkToken) => {
      // Lưu lại token và gán string rỗng cho các thông tin số điện thoại
      const tokenData = {
        ...createEmptyUserData(),
        sdkToken: sdkToken
      }

      saveConfirmedUserData(tokenData)
      setUserData(tokenData)
      return true
    },
    []
  )

  const value = useMemo(
    () => ({
      userData,
      confirmSdkTokenData
    }),
    [userData, confirmSdkTokenData]
  )

  return <AppUserContext.Provider value={value}>{children}</AppUserContext.Provider>
}

export const useAppUserContext = () => {
  const context = useContext(AppUserContext)
  if (!context) {
    throw new Error('useAppUserContext must be used within AppUserContextProvider')
  }
  return context
}
